export default "__VITE_ASSET__b9fa6ac6__"